export const dualLinkProjects = [
  {
    projectName: "RoadSaints: Unleash Your Ride's Potential with Premium Motorcycle Accessories",
    frontendLink: "https://github.com/AdibAhmed317/RoadSaints-ReactJS",
    backendLink: "https://github.com/AdibAhmed317/RoadSaints-ASPDotNet",
  },
];
